import { render, staticRenderFns } from "./SetRecommendations.vue?vue&type=template&id=01b96536&scoped=true&"
import script from "./SetRecommendations.vue?vue&type=script&lang=js&"
export * from "./SetRecommendations.vue?vue&type=script&lang=js&"
import style0 from "./SetRecommendations.vue?vue&type=style&index=0&id=01b96536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b96536",
  null
  
)

export default component.exports